export class OrderRequest {
    // variables
    public supplier_code;
    public company_code;
    public language;
    // editable variables
    public order_number;
    public date_from;
    public date_to;
}



// WEBPACK FOOTER //
// ./src/app/model/order/order_request.model.ts